"use client"

import { useLocale, useTranslations } from "next-intl"
import { useMemo } from "react"
import { LanguageSelector } from "@/components/i18n/language-selector"
import { useConfigurationsQuery } from "@/hooks/react-query/themes"
import { routing } from "@/i18n/routing"

export default function LanguageSwitcher() {
  const t = useTranslations("LocaleSwitcher")
  const currentLocale = useLocale()
  const { grsSettings } = useConfigurationsQuery()
  const availableLanguages = useMemo(() => {
    return grsSettings?.available_languages as ["en", "es", "pt"] ?? ["en", "es", "pt"]
  }, [grsSettings])

  // Opciones de idiomas con etiquetas e íconos
  const languages = useMemo(() => availableLanguages.map((locale: (typeof availableLanguages)[number]) => {
    const secureLanguage = availableLanguages.find(language => language === locale) ? locale : availableLanguages[0]
    return {
      label: t(`languages.${secureLanguage}`),
      value: secureLanguage,
      icon: getFlagIcon(secureLanguage),
    }
  }), [availableLanguages, t])

  return (
    <LanguageSelector
      currentLocale={currentLocale}
      languages={languages}
    />
  )
}

function getFlagIcon(locale: string): string {
  switch (locale) {
    case "en":
      return "twemoji:flag-united-kingdom"
    case "es":
      return "twemoji:flag-spain"
    case "pt":
      return "twemoji:flag-brazil"
    case "az":
      return "twemoji:flag-azerbaijan"
    case "ru":
      return "twemoji:flag-russia"
    default:
      return "lucide:globe"
  }
}
